import React, { useState, useEffect } from 'react';
import contactsFile from '../files/Contacts.txt';
import iconForm from '../image/form.ico'; // Укажи свое имя файла для иконки формы
import iconInfo from '../image/info.ico'; // Укажи свое имя файла для иконки контактов
function Contact() {
  const [status, setStatus] = useState('');
  const [contactsText, setContactsText] = useState('');  
  const [name, setName] = useState('');
  const [contact, setContact] = useState('');
  const [message, setMessage] = useState('');
  const [isAgreed, setIsAgreed] = useState(false);
  useEffect(() => {
    fetch(contactsFile)
      .then(response => response.text())
      .then(data => setContactsText(data));
  }, []);
  const isFormValid = name.trim() !== '' && contact.trim() !== '' && message.trim() !== '' && isAgreed;
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Отправка...');
    
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());
    
    try {
      const response = await fetch('/send.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      
      if (response.ok) {
        setStatus('success');
        e.target.reset(); 
        
        setName('');
        setContact('');
        setMessage('');
        setIsAgreed(false); 
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
      console.error('Ошибка отправки:', error);
    }
  };
  return (
    <div className="fade-in">
      <div className="page-header">
        <h1 className="page-title">Связь с нами</h1>
        <p className="page-subtitle">Готовы обсудить ваш проект? Оставьте заявку, и мы ответим в ближайшее время.</p>
      </div>
      <div className="contact-layout">
        
        <div className="card contact-card">
          <div className="service-icon" style={{ marginBottom: '16px' }}>
            <img src={iconForm} alt="Заявка" />
          </div>
          <h3 className="contact-card-title">Оставить заявку</h3>
          <form className="contact-form" onSubmit={handleSubmit} style={{ margin: 0 }}>
            
            <div className="form-group">
              <label htmlFor="name">Как к вам обращаться?</label>
              <input 
                type="text" 
                id="name" 
                name="name" 
                required 
                placeholder="Ваше имя" 
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="contact">Email или Телефон</label>
              <input 
                type="text" 
                id="contact" 
                name="contact" 
                required 
                placeholder="name@example.com" 
                value={contact}
                onChange={(e) => setContact(e.target.value)}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="message">Суть задачи</label>
              <textarea 
                id="message" 
                name="message" 
                rows="4" 
                required 
                placeholder="Опишите, что нужно разработать..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
            </div>
            
            <div className="form-group" style={{ flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
              <input 
                type="checkbox" 
                id="agreement" 
                checked={isAgreed} 
                onChange={(e) => setIsAgreed(e.target.checked)}
                style={{ width: 'auto', cursor: 'pointer' }}
              />
              <label htmlFor="agreement" style={{ fontSize: '0.85rem', color: 'var(--text-muted)', cursor: 'pointer', fontWeight: 'normal' }}>
                Я согласен на обработку персональных данных
              </label>
            </div>
            
            <button type="submit" className="submit-btn" disabled={!isFormValid || status === 'Отправка...'}>
              {status === 'Отправка...' ? 'Отправляем...' : 'Отправить заявку'}
            </button>
            
            <div className="form-status">
              {status === 'success' && <span className="status-success">✅ Сообщение успешно отправлено!</span>}
              {status === 'error' && <span className="status-error">❌ Ошибка отправки. Попробуйте позже.</span>}
            </div>
            
          </form>
        </div>
        
        <div className="card contact-card">
          <div className="service-icon" style={{ marginBottom: '16px' }}>
            <img src={iconInfo} alt="Контакты" />
          </div>
          <h3 className="contact-card-title">Наши контактные данные</h3>
          <div style={{ whiteSpace: 'pre-wrap', lineHeight: '1.8', color: 'var(--text-main)' }}>
            {contactsText}
          </div>
        </div>
        
      </div>
    </div>
  );
}
export default Contact;